// @ts-check
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { IconButton, ListItemSecondaryAction } from '@material-ui/core';

import DeleteIcon from '@material-ui/icons/Delete';
import Divider from '@material-ui/core/Divider';

import { BackdropComponent } from '../../../../core/utils/components/backdrop-component';
import { SnackbarComponent } from '../../../../core/utils/components/snackbar-component';
import { deleteContractAction } from '../redux/actions/contract-actions';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  inline: {
    display: 'inline'
  },
  heading: {
    margin: theme.spacing(2)
  },
  fab: {
    width: '100%'
  },
  extendedIcon: {
    marginRight: theme.spacing(1)
  },
  clientLogo: {
    height: '8rem',
    width: '8rem',
    objectFit: 'contain'
  },
  list: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }
}));

function ContractList({ contracts }) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [backdrop, setBackdrop] = useState(false);
  const [snackbar, setSnackbar] = useState(false);
  const [message, setMessage] = useState({
    status: 'success',
    description: 'Contract deleted.'
  });

  const showSnackbar = (status = 'success', description = 'Contract deleted.') => {
    setSnackbar(true);
    setMessage({
      status,
      description
    });
    setBackdrop(false);
  };

  const closeSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbar(false);
  };

  const closeBackdrop = () => {
    setBackdrop(false);
  };

  const deleteContract = (contract) => {
    setBackdrop(true);
    const props = { closeBackdrop, showSnackbar };
    dispatch(deleteContractAction(contract.id, props));
  };

  const n = contracts.length - 1;
  const parties = contracts
    .sort((contract_a, contract_b) => {
      if (contract_a.promisee.name < contract_b.promisee.name) {
        return -1;
      }
      if (contract_a.promisee.name > contract_b.promisee.name) {
        return 1;
      }
      return 0;
    })
    .map((contract, index) => {
      return (
        <div key={index}>
          <ListItem button>
            <ListItemText
              primary={`${contract.promisee.name}`}
              secondary={contract.promisee.organization}
            ></ListItemText>

            <ListItemSecondaryAction>
              <IconButton edge="end" aria-label="comments" onClick={() => deleteContract(contract)}>
                <DeleteIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          {index !== n && <Divider />}
        </div>
      );
    });

  return (
    <div className={classes.root}>
      {contracts.length === 0 && <small>no contracts</small>}
      {contracts.length > 0 && <List className={classes.root}>{parties}</List>}

      <>
        <BackdropComponent open={backdrop} />
        <SnackbarComponent
          open={snackbar}
          onClose={closeSnackbar}
          severity={message.status}
          message={message.description}
        />
      </>
    </div>
  );
}

export function PromiseePartiesComponent({ contracts }) {
  const classes = useStyles();

  return (
    <div className={classes.list}>
      <>
        <ContractList contracts={contracts} />
      </>
    </div>
  );
}
